import { useState, useEffect } from 'react';
import { chatPageService } from '../../services/index.js';
import { useNavigate } from 'react-router-dom';

export default function History() {
  const [chatHistory, setChatHistory] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchChatHistory = async () => {
      try {
        const response = await chatPageService.fetchChatHistory();
        setChatHistory(response.data || []);
      } catch (error) {
        console.log('Fetch chat history error:', error);
        setChatHistory([]);
      }
    };
    fetchChatHistory();
  }, []);

  const handleChatClick = (conversationId) => {
    navigate('/user');
  };

  return (
    <section className="flex-1 flex flex-col h-full p-8 overflow-y-auto">
      <div className="max-w-4xl mx-auto w-full">
        <h1 className="text-3xl font-bold text-slate-800 dark:text-white mb-2">Chat History</h1>
        <p className="text-slate-500 dark:text-slate-400 mb-8">View and manage your previous conversations</p>
        
        <div className="space-y-3">
          {chatHistory.length === 0 ? (
            <div className="text-center py-12">
              <p className="text-slate-400 dark:text-slate-500">No chat history found</p>
            </div>
          ) : (
            chatHistory.map((chat) => (
              <div
                key={chat.conversationId || chat.ConversationId}
                onClick={() => handleChatClick(chat.conversationId || chat.ConversationId)}
                className="bg-white dark:bg-slate-800 rounded-2xl p-5 border border-slate-200 dark:border-slate-700 hover:border-[#1d57a5] dark:hover:border-[#4a8ce3] transition-all cursor-pointer group"
              >
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <h3 className="font-semibold text-slate-800 dark:text-white group-hover:text-[#1d57a5] dark:group-hover:text-[#4a8ce3] transition-colors">
                      {chat.title || chat.Title || 'Untitled Conversation'}
                    </h3>
                    <p className="text-sm text-slate-500 dark:text-slate-400 mt-1">
                      {chat.lastMessage || 'No messages yet'}
                    </p>
                  </div>
                  <div className="text-xs text-slate-400 dark:text-slate-500">
                    {new Date(chat.updatedAt || chat.createdAt).toLocaleDateString()}
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </section>
  );
}
